import { defineComponent as _defineComponent } from 'vue'
import SwitchBetweenInput from '@/components/inputs/SwitchBetweenInput.vue';
import { getPackagePricesByType } from '@/lib/billing/billingFunctions';
import { PlanNameEnum } from '@/lib/enum/billing/BillingEnum';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import store from '@/store';
import { viewport } from '@/util/windowFunctions';
import PackageCardV2 from '@/views/sign-up/components/PackageCardV2.vue';
import { computed } from 'vue';
import {
  BillingDetails,
  BillingPackage,
  BillingPackageIntervalEnum,
  BillingPaymentMethod,
  BillingProductTypeEnum,
} from '../../../../api/v1';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseBillingPlan',
  props: {
    subscriptionInterval: { default: BillingPackageIntervalEnum.Monthly },
    billingDetails: { default: null },
    paymentMethods: { default: null }
  },
  emits: ["trialPackage", "choosePackage", "toggleInterval"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'trialPackage', billingPackage: BillingPackage): void;
  (e: 'choosePackage', billingPackage: BillingPackage): void;
  (e: 'toggleInterval', interval: BillingPackageIntervalEnum): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { subscriptionInterval: BillingPackageIntervalEnum, billingDetails: BillingDetails, paymentMethods: BillingPaymentMethod[] }





const billingPackages = realtimeQuery(Entity.BillingPackage)
  .where('allowsSignups', 'eq', true)
  .fetch();
const currentPackage = computed(() => store.getters['billing/currentPackage']);
const isTrialVersion = computed(() => store.getters['billing/isTrialVersion']);
const filteredPackages = computed(() =>
  billingPackages.data.filter((p) => p.interval === props.subscriptionInterval),
);

const isCurrentPackage = (billingPackage: BillingPackage): boolean =>
  billingPackage.id === currentPackage.value.id;

return { __sfc: true,props, emit, billingPackages, currentPackage, isTrialVersion, filteredPackages, isCurrentPackage, SwitchBetweenInput, getPackagePricesByType, PlanNameEnum, viewport, PackageCardV2, BillingPackageIntervalEnum, BillingProductTypeEnum }
}

})